export function pick(obj: Record<string, unknown>, keys: string[]) {
    const r: Record<string, unknown> = {};
    for (const key of keys) {
      if (obj[key] != null) {
        r[key] = obj[key];
      }
    }
    return r;
  }